export default function findNeighborsId(staticArr, currentNodeId){
  const targetArr = staticArr[currentNodeId];
  let result = [];
  targetArr.forEach((ele, index) => {if (ele !== 0 && ele !== Infinity) result.push(index)});
  return result;
};